import { Route, Routes } from "react-router-dom";
import customHeaders, { getSpace } from '../../../common/headers'
import plus_icon from './img/plus_icon.svg'
import user_icon from './img/user_icon.svg'
import { useDebounce } from '../../../hooks/useDebounce'
import { RavshanHttps } from '../../../fetchUrls'
import { ModalAddProject } from "../../ComponentsCommonTasksLogic/Modal/ModalAddProject/ModalAddProject";
import { useNavigate, useParams } from 'react-router-dom'
import { useState, useEffect, useRef } from 'react'
import { ButtonBasic, NotActive, ViewSwitch, InputDynamicWidth, Tabs, usePagination, Sceleton, NoDataContent } from "@lk-gtcom/ecomlab-components";
import ProjectCard from "../../ComponentsCommonTasksLogic/CardsProject/ProjectCard/ProjectCard";
import ProjectCardList from "../../ComponentsCommonTasksLogic/CardsProject/ProjectCardList/ProjectCardList";
import useGeneralStore from '../../../store/general'
import { AuthorAvatar } from "../../ArticleComponents/AuthorAvatar/AuthorAvatar";
import { ButtonsSort } from '../../../components/Buttons/BurronsSort/ButtonsSort'
import { TitlePage } from '../../../components/TitlePage/TitlePage'
import { usePushNotifications } from "../../../common/pushNotification";
import { ButtonWithIcon } from "../../../components/Buttons/ButtonWithIcon/ButtonWithIcon";
import "./ProjectForTasks.scss"

const btn_sort = [
    { label: 'A-Z', value: 'name' },
    { label: 'По дате создания', value: 'date' },
    { label: 'Задач', value: 'tasksCount' },
]

const arrNames = (arr_names, author) => {
    return arr_names?.map(({ name, login, color, id }, ind) => {
        return <AuthorAvatar
            size='s'
            group
            key={id}
            author={[name, color]}
        />
    })
}

const ProjectForTasks = ({ setSelectedProject, selectedProject }) => {
    const selectedSpace = useGeneralStore(state => state.selectedSpace)
    const headers = { ...customHeaders, ...getSpace(selectedSpace) }
    const navigate = useNavigate()
    const path = useParams()['*']

    const email = localStorage.getItem('email')
    const [isFavorite, setIsFavorite] = useState(false)
    const [loading, setLoading] = useState(true)
    const [projects, setProjects] = useState([])
    const [isModalAddProject, setIsModalAddProject] = useState(false)
    const [isSelectedProjectLS, setIsSelectedProjectLS] = useState(false)
    const [isInfoProject, setIsInfoProject] = useState(false)
    const [view, setView] = useState('Tile-short')
    const [isShowAllExecutor, setIsShowAllExecutor] = useState(false)
    const [authorName, setAuthorName] = useState(email)
    const [selectedExecutor, setSelectedExecutor] = useState([])
    const [currentSort, setCurrentSort] = useState(null)
    const [sort, setSort] = useState(null)
    const [search, setSearch] = useState('')

    // Обработка ошибок
    const { addErrorPush, addSuccessPush } = usePushNotifications();

    // Пагинация
    const paginatorRef = useRef()
    const paginatorCallback = useRef();
    const [
        page,
        limit,
        setTotal,
        Paginator,
    ] = usePagination(
        paginatorCallback.current,
        [],
        paginatorRef?.current?.params
    );

    // Получение проектов задач
    const fetchProjects = (abortController = new AbortController()) => {
        setLoading(true)
        const url = `${RavshanHttps}/api/v2/tasks/get_project`

        const body = JSON.stringify({
            page: page,
            limit: limit,
            executor: selectedExecutor,
            search,
            order_param: currentSort?.value ? currentSort?.value : 'name',
            order_param_direction: sort ? sort : 'ASC',
            table_type: false,
            is_favorite: isFavorite
        })

        const options = { body, method: 'POST', headers, signal: abortController.signal }

        fetch(url, options)
            .then(res => res.json())
            .then(json => {
                const { data, total } = json
                if (Array.isArray(data)) {
                    setProjects(data)
                    setTotal(total)
                }
            })
            .catch(err => console.error(err))
            .finally(() => {
                if (abortController.signal.aborted) return
                setLoading(false)
            })
    }

    // Удаление проекта задач
    const deleteProject = (id) => {
        let url = ` https://portals.ecomru.ru/api/v3/tasks/${id}`;

        fetch(url, { method: 'DELETE', headers })
            .then(async (res) => {
                if (res.ok) {
                    setTimeout(() => fetchProjects(), 500)
                    sessionStorage.removeItem('selectedProject');
                    addSuccessPush(`Проект ID-${id} успешно удален`)
                } else {
                    const err = await res.json();
                    addErrorPush(`Ошибка удаления. ${err?.detail}`)
                    throw new Error('bad post project response');
                }
            })
            .catch((err) => console.error(err));
    };

    useEffect(() => {
        if (!isModalAddProject) {
            const abortController = new AbortController()
            setTimeout(() => fetchProjects(abortController), 100)
            setSelectedProject(null)
            return () => abortController.abort()
        }
    }, [isModalAddProject, sort, currentSort, page, limit, isFavorite, search])

    useEffect(() => {
        const selectedProjectLS = sessionStorage.getItem('selectedProject')
        if (selectedProjectLS) {
            setSelectedProject(JSON.parse(selectedProjectLS))
        } else {
            if (path) {
                const project = projects?.filter(el => el?.id === path)
                if (project?.length > 0) {
                    sessionStorage.setItem('selectedProject', JSON.stringify(...project))
                    setSelectedProject(...project)
                }
            }
        }
    }, [projects])

    const handleGetProject = useDebounce(fetchProjects, 1000)
    const project_sorting = projects?.sort((a, b) => b.isFavorite - a.isFavorite)


    return (
        <>
            {isModalAddProject && <ModalAddProject
                isInfoProject={isInfoProject}
                setIsInfoProject={(e) => setIsInfoProject(e)}
                selectedProject={selectedProject}
                setIsModal={(e) => setIsModalAddProject(e)}
                isSelectedProjectLS={isSelectedProjectLS}
                setIsSelectedProjectLS={e => setIsSelectedProjectLS(e)}
                task
            />}

            <div className='project-for-tasks'>
                <TitlePage
                    title={'Задачи'}
                />

                <div className='project-for-tasks__filters'>
                    <div className='project-for-tasks__btn-group'>
                        <ButtonBasic
                            disabled={loading}
                            green
                            width='240px'
                            onClick={(e) => setIsModalAddProject(true)}
                            icon={plus_icon}
                            text={'Добавить новый проект'}
                        />

                        <ButtonBasic
                            disabled={loading}
                            grey
                            width='240px'
                            onClick={(e) => {
                                const project = projects?.filter(el => el?.task_id === -1)
                                const { task_id, name } = project[0]
                                setSelectedProject(project)
                                sessionStorage.setItem('taskProjectName', name)
                                sessionStorage.setItem('taskProjectId', task_id)
                                navigate(`/tasks/task-list/${task_id}?filter=my_project`)
                            }}
                            text={'Посмотреть мои задачи'}
                            icon={user_icon}
                        />

                        <ButtonBasic
                            disabled={loading}
                            grey
                            width='240px'
                            icon={user_icon}
                            text={'Просмотр по сотрудникам'}
                            onClick={(e) => {
                                const project = projects?.filter(el => el?.task_id === -1)
                                const { task_id, name } = project[0]
                                setSelectedProject(project)
                                sessionStorage.setItem('taskProjectName', name)
                                sessionStorage.setItem('taskProjectId', task_id)
                                navigate(`/tasks/task-list/${task_id}`)
                            }}
                        />
                    </div>

                    <div className='project-for-tasks__filters_right'>
                        <InputDynamicWidth
                            position='left'
                            maxWidth='100%'
                            value={search}
                            onChange={setSearch}
                            disabled={loading}
                        />

                        <ButtonWithIcon
                            favorite
                            whiteGreen
                            changeValue={isFavorite}
                            size='m'
                            onClick={(e) => {
                                setIsFavorite(!isFavorite)
                            }}
                        />

                        <ButtonsSort
                            btnSort={btn_sort}
                            sort={sort}
                            setSort={setSort}
                            currentSort={currentSort}
                            setCurrentSort={setCurrentSort}
                            disabled={loading}
                        />

                        <ViewSwitch
                            table={false}
                            selectView={view}
                            setSelectView={(e) => setView(e)}
                            disabled={loading}
                        />
                    </div>
                </div>

                <div className='project-for-tasks__content'>
                    {
                        (loading && view != 'Table')
                            ?
                            <div className='project-for-tasks__box-card'
                            >
                                {
                                    [...Array(12)].map((el, ind) => {
                                        return <Sceleton
                                            width={'240px'}
                                            height={'289px'}
                                            key={ind}
                                        />
                                    })
                                }
                            </div>
                            :
                            (
                                (projects?.length < 1) ?
                                    <NoDataContent
                                        title="У Вас еще нет проектов"
                                        description="Создайте новый проект и формируйте в нем задачи"
                                        child={
                                            <ButtonBasic
                                                violet
                                                onClick={(e) => setIsModalAddProject(true)}
                                                text='Создать проект'
                                                width='150px'
                                                size='56px'
                                            />
                                        }
                                    />
                                    :
                                    <>
                                        {(view == 'Tile-short') && <div className='project-for-tasks__box-card'>
                                            {project_sorting.map((project) => (
                                                <ProjectCard
                                                    key={project?.task_id}
                                                    project={{
                                                        ...project,
                                                        taskId: project?.task_id,
                                                    }}
                                                    setSelectedProject={setSelectedProject}
                                                    setIsInfoProject={setIsInfoProject}
                                                    setIsModalAddProject={setIsModalAddProject}
                                                    isShowAllExecutor={isShowAllExecutor}
                                                    arrNames={arrNames}
                                                    authorName={authorName}
                                                    deleteProject={deleteProject}
                                                    fetchProjects={fetchProjects}
                                                />
                                            ))}
                                        </div>}

                                        {(view == 'Tile-long') && <div className='project-for-tasks__list-card'>
                                            {project_sorting.map((project) => (
                                                <ProjectCardList
                                                    key={project?.task_id}
                                                    project={{
                                                        ...project,
                                                        taskId: project?.task_id,
                                                    }}
                                                    setSelectedProject={setSelectedProject}
                                                    setIsInfoProject={setIsInfoProject}
                                                    setIsModalAddProject={setIsModalAddProject}
                                                    isShowAllExecutor={isShowAllExecutor}
                                                    arrNames={arrNames}
                                                    authorName={authorName}
                                                    deleteProject={deleteProject}
                                                    fetchProjects={fetchProjects}
                                                />
                                            ))}
                                        </div>}

                                        {(view == 'Table') && <NotActive />}
                                    </>
                            )
                    }
                </div>

                {Paginator}
            </div >
        </>
    )
}

export { ProjectForTasks }